import {
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);
export const options = {
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        color: 'rgba(0,0,0,0.1)',
      },
      border: {
        dash: [2, 6],
      },
    },
    y: {
      grid: {
        display: false,
      },
    },
  },
};

export const PieChart = ({ pastEventsChartData }) => {
  const [GraphData, setGraphData] = useState([]);
  const [labels, setLabels] = useState([]);
  useEffect(() => {
    let tempData = [];
    let tempDate = [];
    pastEventsChartData?.filter((item) => {
      tempData.push(item?.count);
      tempDate.push(item?.date);
    });

    setGraphData(tempData);
    setLabels(tempDate);
  }, [pastEventsChartData]);

  const data = {
    labels,
    datasets: [
      {
        fill: true,
        label: '',
        data: GraphData,
        borderColor: 'rgba(76, 184, 72,0.3)',
        backgroundColor: 'rgb(76, 184, 72)',
      },
    ],
  };
  return (
    <>
      <div className='d-flex justify-content-center w-100 pieChart'>
        <Line
          // legend={false}
          options={options}
          data={data}
          style={{ width: 400, height: 400 }}
        />
      </div>
    </>
  );
};
